module.exports = __webpack_public_path__ + "static/media/wifi-slash.2dc45af1.svg";